import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translate } from '@fiverr-private/i18n-react';
import HeaderRating from '../Rating/HeaderRating';
import Summary from './Summary';

import './styles.scss';

/**
 * @param {string} title - title translation key to be displayed
 * @param {number} ratingFive - average rating score
 * @param {Object} starSummary - breakdown
 * @param {number} totalCount - amount of ratings
 * @param {func} toggleCollapsed - on collapse toggle callback
 * @param {boolean} displayVerified - verified by customers who bought this service
 * @param {boolean} showBreakdown - is breakdown displayed
 * @returns {JSX.Element} - Reviews header component
 **/
const Header = ({
    title,
    ratingFive = null,
    starSummary = null,
    totalCount = 0,
    displayVerified = false,
    showBreakdown = false,
    isBuyerProfile = false,
}) => (
    <header className={classNames('reviews-header', { 'breakdown-header': showBreakdown })}>
        <div className="details">
            <h2 className="text-display-7">
                <HeaderRating
                    header={translate(title)}
                    score={ratingFive}
                    isBuyerProfile={isBuyerProfile}
                    ratingsCount={totalCount}
                />
            </h2>
        </div>
        {!showBreakdown && <Summary displayVerified={displayVerified} starSummary={starSummary} />}
    </header>
);

Header.propTypes = {
    title: PropTypes.string,
    ratingFive: PropTypes.number,
    starSummary: PropTypes.object,
    totalCount: PropTypes.number,
    displayVerified: PropTypes.bool,
    showBreakdown: PropTypes.bool,
};

export default Header;
